import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowBottomRightCorner: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareArrowBottomRightCorner"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM9.58594 11L13.5859 15H11V17H17V11H15V13.5859L11 9.58594L9.58594 11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowBottomRightCorner;
